import { useState } from "react";
import api from "../lib/api";
import { ArrowRight, AlertOctagon } from "lucide-react";
import { toast } from "sonner";

export default function LargeJobs() {
  const [form, setForm] = useState({
    organization: "", contact_name: "", email: "", phone: "",
    unit_count: 100, budget_cad: 250000, asset_types: "", target_completion: "", description: "",
  });
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/large-jobs", form);
      setResult(data);
      if (data.qualified) toast.success("Priority intake received.");
      else toast.success("Request received.");
    } catch { toast.error("Submission failed."); }
  };

  return (
    <>
      <section className="bg-[#064E3B] text-white" data-testid="large-jobs-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <div className="federal-stamp" style={{ borderColor: "#FACC15", color: "#FACC15", background: "rgba(250,204,21,0.08)" }}>
            ★ PRIORITY CHANNEL · 100+ UNITS · $250K+ BUDGET
          </div>
          <h1 className="display-black text-5xl lg:text-6xl uppercase mt-6 tracking-tighter max-w-4xl leading-[0.95]">
            Got scale? We'll talk now.
          </h1>
          <p className="text-lg text-white/85 mt-6 max-w-2xl">
            Fleet operators, dealerships, marinas, municipalities, asset managers. If you meet either threshold, a senior coordinator calls you within 24 hours.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-3">
            {result ? (
              <div className={`border p-10 ${result.qualified ? "border-[#D97706] bg-red-50" : "border-gray-300 bg-gray-50"}`} data-testid="large-job-result">
                <div className="flex items-center gap-3">
                  {result.qualified && <AlertOctagon className="w-6 h-6 text-[#D97706]" />}
                  <div className="display-black text-2xl uppercase text-[#064E3B]">
                    {result.qualified ? "★ Priority Intake Received" : "Request Received"}
                  </div>
                </div>
                <p className="text-gray-800 mt-3">{result.message}</p>
                <button onClick={() => setResult(null)} className="btn-ghost mt-6">Submit another</button>
              </div>
            ) : (
              <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-5 border border-gray-300 p-8" data-testid="large-job-form">
                <input className="input-federal md:col-span-2" required placeholder="Organisation" value={form.organization} onChange={e => setForm({...form, organization: e.target.value})} data-testid="lj-org" />
                <input className="input-federal" required placeholder="Contact name" value={form.contact_name} onChange={e => setForm({...form, contact_name: e.target.value})} data-testid="lj-contact" />
                <input className="input-federal" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="lj-email" />
                <input className="input-federal" required placeholder="Phone" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} data-testid="lj-phone" />
                <input className="input-federal" required placeholder="Target completion (date or window)" value={form.target_completion} onChange={e => setForm({...form, target_completion: e.target.value})} data-testid="lj-target" />
                <input className="input-federal" required type="number" min={1} placeholder="Unit count (100+ qualifies)" value={form.unit_count} onChange={e => setForm({...form, unit_count: parseInt(e.target.value)||1})} data-testid="lj-units" />
                <input className="input-federal" required type="number" min={1} placeholder="Budget USD ($250k+ qualifies)" value={form.budget_cad} onChange={e => setForm({...form, budget_cad: parseInt(e.target.value)||1})} data-testid="lj-budget" />
                <input className="input-federal md:col-span-2" required placeholder="Asset types (RVs, semi-trailers, boats…)" value={form.asset_types} onChange={e => setForm({...form, asset_types: e.target.value})} data-testid="lj-assets" />
                <textarea className="input-federal md:col-span-2" rows={5} required placeholder="Describe the scope and constraints…" value={form.description} onChange={e => setForm({...form, description: e.target.value})} data-testid="lj-description" />
                <button type="submit" className="btn-signal md:col-span-2 justify-center" data-testid="lj-submit">Submit Priority Intake <ArrowRight className="w-4 h-4" /></button>
              </form>
            )}
          </div>
          <aside className="lg:col-span-2">
            <div className="border border-gray-300 p-7 bg-gray-50">
              <div className="mono text-[10px] tracking-[0.22em] uppercase text-[#D97706]">// Qualification</div>
              <h3 className="display-black text-xl uppercase text-[#064E3B] mt-3">Either threshold qualifies</h3>
              <ul className="mt-5 space-y-3 text-sm text-gray-800">
                <li><span className="font-bold">100+</span> assets to be removed in a single engagement, OR</li>
                <li><span className="font-bold">$250,000+</span> total project budget, OR</li>
                <li>Multi-jurisdiction projects (federal/state/provincial coordination)</li>
                <li>Asset-class specialist (aviation / marine / heavy)</li>
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}
